import React from 'react'
import EmpImage from '../../assets/images/hr/img01.jpg'
import EmpImage1 from '../../assets/images/hr/img02.jpg'
import EmpImage2 from '../../assets/images/hr/img03.jpg'
import EmpImage3 from '../../assets/images/hr/img04.jpg'
import { Link } from 'react-router-dom';

function Employees() {
    return (
        <React.Fragment>
            <div id="voices">
                <div className="container-box" id="voices">
                    <div className='row row-title'>
                        <div className='col col-hr'><hr></hr></div>
                        <div className='col-12 col-md-6'>
                            <h1 className="text-blue">先輩社員の声</h1>
                            <h5>HEAR FROM OUR ACTIVE SENIOR EMPLOYEES</h5>
                        </div>
                        <div className='col col-hr'><hr></hr></div>
                    </div>
                </div>
                <div className="container-box" id="recruitHR-employee-list-container">
                    <div className="row mb-5">
                        {/* mobile show */}
                        <div className="col-12 col-sm-12 mt-auto mb-auto mb-show text-center">
                            <img src={EmpImage1} alt="employee2" className="img-thumbnail" />
                        </div>
                        {/* mobile show */}
                        <div className="col">
                            <h5 className="text-end">システム部 (2016年入社)</h5>
                            <p>
                                NALの良い所は、「自分の力量を知り、上に伸ばせる環境がある」ということです。<br />
                                まず、会社の業務は客先に常駐しての仕事が多いため、自分と他社の人を比較することができる機会が多くあります。
                                また、少人数で客先へ出向くことも多いので、個々の作業範囲が広く、自分の力量を明確にできます。幅広い作業のおかげで、
                                苦手分野を克服して得意分野を向上させることができました。
                                は、徐々に作業量を増やし、どのようにしたら予定通りに成果が出せるのかを考えながら、仕事をすることにやりがいを感じています。
                            </p>
                        </div>
                        {/* mobile hide  */}
                        <div className="col-4 mt-auto mb-auto mb-hide">
                            <img src={EmpImage1} alt="employee2" className="img-thumbnail" />
                        </div>
                        {/* mobile hide  */}
                    </div>
                    {/* <div className="row mb-5"> */}
                        {/* mobile show */}
                        {/* <div className="col-12 col-sm-12 mt-auto mb-auto mb-show text-center">
                            <img src={EmpImage2} alt="employee3" className="img-thumbnail" />
                        </div> */}
                        {/* mobile show */}

                        {/* mobile hide  */}
                        {/* <div className="col-4 mt-auto mb-auto mb-hide">
                            <img src={EmpImage2} alt="employee3" className="img-thumbnail" />
                        </div> */}
                        {/* mobile hide  */}
                        {/* <div className="col">
                            <h5 className="text-start">システム部 (2003年入社)</h5>
                            <p>
                                入社するまでは、システム開発やコンピュータのことは全くと言っていいほど知りませんでした。
                                しかし、分からないことはすぐに上司や先輩に聞くことが出来ましたので、困るということはありませんでした。
                                もちろん、一から十まで全て教えてもらえるという訳ではありません。いろいろな環境を経験することで、
                                自分で考えて解決するという力を身に付けることが出来ました。
                                そんな私が今ではプロジェクトリーダーとして、お客様から依頼されたシステム開発をメンバーと協力して進めています。
                                チームとしての力を引き出すことができる環境を作ること、高いモチベーションを維持してプロジェクト完了に向かうための推進力をチ
                                ームに与えることが自分の役割だと思っています。また、そのことでチームも自分も大きく成長できると考えています。
                            </p>
                        </div>
                    </div> */}
                    <div className="row mb-5">
                        {/* mobile show  */}
                        <div className="col-12 col-sm-12 col-md-4 mt-auto mb-auto mb-show text-center">
                            <img src={EmpImage3} alt="employee4" className="img-thumbnail" />
                        </div>
                        {/* mobile show  */}

                        {/* mobile hide  */}
                        <div className="col-4 mt-auto mb-auto mb-hide">
                            <img src={EmpImage3} alt="employee4" className="img-thumbnail" />
                        </div>
                        {/* mobile hide  */}
                        <div className="col">
                            <h5 className="text-start">経営業務部 (2015年入社)</h5>
                            <p>
                                私は経営業務部で総務・人事の仕事をしています。主な仕事は給与処理や健康診断の手配など社員の皆さんが気持ちよく働けるようにサポートすることです。<br />
                                総務・人事はイレギュラーな仕事が多く、いろいろな状況にあわせて対応をしていくため大変です。でも「対応してくれてありがとう
                                」と言われることに喜びを感じています。まだまだ一人で解決できないことが多く、上司に教えていただくことがありますが、
                                経験を積み少しずつ自分ができる仕事が増えていく毎日は充実しています。
                            </p>
                        </div>
                        
                    </div>
                    <div className="row mb-5">
                        <div className="col">
                            <div className="button">
                                <Link to="/recruit" className="btn-link" >募集内容はこちら<i className="fa fa-arrow-circle-right" aria-hidden="true"></i></Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default Employees
